//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
export default {
  name: 'ReviewsPage',
  data: () => ({
    page: 1,
    filterCountry: true
  }),
  async fetch () {
    await Promise.all([
      this.$store.dispatch('review/GET_SUMMARY'),
      this.$store.dispatch('review/GET_REVIEWS', { page: 1 })
    ])
  },
  head () {
    return {
      title: this.getTitle('Product Reviews'),
      meta: [
        ...this.getDescription('Rated {rating}/5 by {count} verified customers. {percentage} of customers would recommend SunGod to a friend.', {
          rating: this.$tn(this.rating || 4.8, 2),
          count: this.$tn(this.count || 1420),
          percentage: this.$tp(this.recommendRate || 0.995)
        }),
        { hid: 'og:title', property: 'og:title', content: this.getTitle('Product Reviews') }
      ]
    }
  },
  computed: {
    ...mapGetters({
      count: 'review/count',
      rating: 'review/rating',
      recommendRate: 'review/recommendRate',
      pages: 'review/reviewPages',
      pagesLoaded: 'review/pagesLoaded'
    }),
    reviews () {
      return this.$store.getters['review/reviews'](this.page)
    }
  },
  methods: {
    async loadPage (pageNumber) {
      if (pageNumber === '...') return
      else if (pageNumber === '<') pageNumber = this.page - 1
      else if (pageNumber === '>') pageNumber = this.page + 1
      if (this.page === pageNumber || pageNumber <= 0 || pageNumber > this.pages) return

      if (!this.pagesLoaded.includes(pageNumber)) {
        await this.$store.dispatch('review/GET_REVIEWS', { page: pageNumber })
      }

      this.page = pageNumber
      this.$scrollTo('#reviews-page-header')
    }
  }
}
